import { useInfiniteQuery } from '@tanstack/react-query';
import { ConversationPage } from '../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import { performEnterpriseGPTApiCall } from './useMiddlewareApiCall';

interface UseInfiniteConversationsOptions {
    projectId?: string | null;
    limit?: number;
    enabled?: boolean;
    initialCursor?: string; // Cursor to start pagination from
}


function getPageSize(): number {
    return 28;
}

/**
 * Returns the initial page size for conversation loading on app startup
 * This can be modified to adjust the number of conversations loaded initially
 */
export function getInitialConversationPageSize(): number {
    return getPageSize();
}

/**
 * Returns the default page size for conversation pagination
 * This can be modified to adjust the number of conversations loaded per page
 */
export function getDefaultConversationPageSize(): number {
    return getPageSize();
}


export function useInfiniteConversations({
    projectId = null,
    limit = getDefaultConversationPageSize(),
    enabled = true,
    initialCursor,
}: UseInfiniteConversationsOptions = {}) {
    
    const fetchConversations = async ({ pageParam }: { pageParam?: string }): Promise<ConversationPage> => {
        return new Promise((resolve, reject) => {
            performEnterpriseGPTApiCall(async (client, signal) => {
                try {
                    const result = await client.getConversationsPaged(
                        projectId ?? undefined,
                        pageParam,
                        limit,
                        false, // fullLoad = false
                        signal
                    );
                    resolve(result);
                } catch (error) {
                    reject(error);
                }
            });
        });
    };

    return useInfiniteQuery({
        queryKey: ['conversations', projectId, limit],
        queryFn: fetchConversations,
        getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
        initialPageParam: initialCursor as string | undefined,
        enabled,
    });
}
